export default __webpack_public_path__ + "static/media/Verify.d3b713a6.svg";